import {AUTH_CHECK, AUTH_ERROR, AUTH_GET_PERMISSIONS, AUTH_LOGIN, AUTH_LOGOUT} from 'react-admin';
import {get} from 'axios';
import env from "../env";
import {isKeycloakAuthenticated, keycloakLogout, refreshKeycloakToken} from '../keycloak';
import {AUTH_MODE, clearAuthSession, getAuthMode, storeAppSession} from '../auth/authStorage';
import {decodeAppToken} from '../auth/token';
import {exchangeKeycloakToken} from './keycloak-token-exchange';

const loadLegacyExtraData = (decoded) => {
    const tenantType = decoded.tenantType;
    const showInfo = sessionStorage.getItem('showInfo');

    if (tenantType === 'SCHOOL') {
        const url = `${env.baseURL}/api/schoolYears?sort=enable,desc,name,desc`;
        const config = {
            headers: {
                'content-type': 'application/json',
                'Authorization': localStorage.getItem('token')
            }
        };
        get(url, config).then(rs => {
            if (rs.data) {
                localStorage.setItem('schoolYears', JSON.stringify(rs.data.content));
                localStorage.setItem('schoolYear', rs.data.content[0]);
                if (showInfo !== '1') {
                    window.location.reload();
                }
            }
        }).catch(() => {
        });
    }

    if (showInfo === '1') {
        sessionStorage.removeItem('showInfo');
        window.location.href = sessionStorage.getItem('showInfoUrl');
    }
};

const getRolesFromToken = (decoded) => {
    if (!decoded) return ['GUEST'];

    if (decoded.roles && Array.isArray(decoded.roles)) {
        return decoded.roles;
    }

    const realmRoles = decoded?.realm_access?.roles || [];
    const clientRoles = decoded?.resource_access?.['navi-edu']?.roles || [];

    return [...new Set([...realmRoles, ...clientRoles])];
};

export default (loginURL) => {
    return async (type, params) => {
        if (type === AUTH_LOGIN) {
            const {partnerId, authToken} = params || {};

            const request = new Request(`${env.baseURL}/api/public/login-sso-partner`, {
                method: 'POST',
                body: JSON.stringify({partnerId, authToken}),
                headers: new Headers({'Content-Type': 'application/json'}),
            });

            return fetch(request)
                .then(response => {
                    if (response.status < 200 || response.status >= 300) {
                        throw new Error(response.statusText);
                    }
                    return response.json();
                })
                .then(json => {
                    const token = json.token;
                    const decoded = decodeAppToken(token);

                    const mode = (params && params.loginType === 'keycloak-sso') ? AUTH_MODE.SSO : AUTH_MODE.LEGACY;
                    storeAppSession(token, decoded, mode);
                    if (params && params.keycloakToken) {
                        localStorage.setItem('keycloakToken', params.keycloakToken);
                    }
                    loadLegacyExtraData(decoded);
                    return token;
                });

            // Standard login is disabled
            return Promise.reject('LOGIN_DISABLED');
        }

        if (type === AUTH_LOGOUT) {
            const mode = getAuthMode();

            if (mode === AUTH_MODE.SSO) {
                keycloakLogout();
                return new Promise(() => {
                }); // page will redirect
            }

            clearAuthSession();
            return Promise.resolve();
        }

        if (type === AUTH_ERROR) {
            const status = params.status;

            if (status === 401) {
                clearAuthSession();
                return Promise.reject();
            }

            if (status === 403) {
                return Promise.resolve();
            }

            return Promise.resolve();
        }

        if (type === AUTH_CHECK) {
            const mode = getAuthMode();

            if (window.location.hash.includes('/unauthorized')) {
                return Promise.resolve();
            }

            if (mode === AUTH_MODE.SSO) {
                if (isKeycloakAuthenticated()) {
                    return refreshKeycloakToken()
                        .then((newToken) => {
                            if (!localStorage.getItem('token')) {
                                return exchangeKeycloakToken(newToken);
                            }
                            return Promise.resolve();
                        })
                        .catch(() => Promise.reject());
                }
                // Fallback: keycloak session lost but local token still valid
                if (localStorage.getItem('token')) {
                    return Promise.resolve();
                }
                // If we are on the login page or in the middle of a Keycloak callback, don't reject (to avoid logout loop)
                if (window.location.hash.includes('/login') || window.location.search.includes('state=')) {
                    return Promise.resolve();
                }
                return Promise.reject();
            }

            return localStorage.getItem('token')
                ? Promise.resolve()
                : Promise.reject();
        }

        if (type === AUTH_GET_PERMISSIONS) {
            const token = localStorage.getItem('token');

            if (token) {
                const decoded = decodeAppToken(token);
                const roles = getRolesFromToken(decoded);
                return Promise.resolve(roles.length ? roles : ['GUEST']);
            }

            return Promise.resolve(['GUEST']);
        }

        console.warn('Unknown type', type);
        return Promise.reject();
    };
};
